import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);
const state = {
  // user: JSON.parse(sessionStorage.getItem('user'))||{}, //用户信息
  user: null, //用户信息
  // token:null,
  // userId:null,
  // navlist:[], //公共数据
  Address: null //存得地址数据
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {} //模块细分，没个都有自己的satae,mutatuon,action,state
});
